import React from 'react';
import {Box, Input as NativeInput, FormControl} from 'native-base';
import {FieldError, useController, UseControllerProps} from 'react-hook-form';
import {message} from '../../../utils/messages';
import {defaultProps} from '../constants';
import {buildMaskInputProps} from './masked-input.hook';
import {MaskedType} from './masked.interfaces';
import {maskedInputRules} from './masked-commons';

interface Props extends UseControllerProps<any> {
  label: string;
  error: FieldError | undefined;
  mask: MaskedType;
  isEditable?: boolean;
}

const MaskedInput = (props: Props) => {
  const {
    label,
    mask: maskType,
    control,
    name,
    rules,
    error,
    isEditable,
  } = props;
  const {field} = useController({control, defaultValue: '', name, rules});
  const input = {
    value: field.value,
    onChange: field.onChange,
    onChangeText: field.onChange,
  };

  const masked = buildMaskInputProps(
    input,
    maskedInputRules.getType(maskType),
    maskedInputRules.getMaskProps(maskType),
  );

  const isInvalid = () => {
    return error != null;
  };

  const getMessage = (text: string) => {
    return message(text).trim();
  };

  const getErrorMessage = () => {
    return error != null ? message(error.message as string) : '';
  };

  const getIsReadOnly = () => {
    if (isEditable !== undefined) {
      return !isEditable;
    }
    return false;
  };

  return (
    <Box width="100%" marginBottom={5}>
      <FormControl isRequired isInvalid={isInvalid()}>
        <FormControl.Label>{getMessage(label)}</FormControl.Label>
        {maskType === 'money' && (
          <NativeInput
            {...defaultProps}
            keyboardType="number-pad"
            maxLength={13}
            {...masked}
            isReadOnly={getIsReadOnly()}
            backgroundColor={getIsReadOnly() ? '#F8F8F8' : null}
          />
        )}
        {maskType === 'phone' && (
          <NativeInput
            {...defaultProps}
            keyboardType="number-pad"
            maxLength={12}
            {...masked}
            isReadOnly={getIsReadOnly()}
          />
        )}
        {maskType === 'phone-base' && (
          <NativeInput
            {...defaultProps}
            keyboardType="number-pad"
            maxLength={12}
            {...masked}
            isReadOnly={getIsReadOnly()}
          />
        )}
        {maskType === 'document-number' && (
          <NativeInput
            {...defaultProps}
            keyboardType="number-pad"
            maxLength={12}
            {...masked}
            isReadOnly={getIsReadOnly()}
          />
        )}
        {maskType === 'c2p-key' && (
          <NativeInput
            {...defaultProps}
            keyboardType="number-pad"
            maxLength={12}
            {...masked}
            isReadOnly={getIsReadOnly()}
          />
        )}
        {maskType === 'credit-card-ccv' && (
          <NativeInput
            {...defaultProps}
            keyboardType="number-pad"
            maxLength={3}
            {...masked}
            isReadOnly={getIsReadOnly()}
            type="password"
          />
        )}
        {maskType === 'credit-card-expire' && (
          <NativeInput
            {...defaultProps}
            keyboardType="number-pad"
            maxLength={5}
            {...masked}
            isReadOnly={getIsReadOnly()}
          />
        )}
        {maskType === 'credit-card-number' && (
          <NativeInput
            {...defaultProps}
            keyboardType="number-pad"
            maxLength={4 * 4 + 3}
            {...masked}
            isReadOnly={getIsReadOnly()}
          />
        )}
        {maskType === 'voucher' && (
          <NativeInput
            {...defaultProps}
            keyboardType="default"
            maxLength={29}
            {...masked}
            isReadOnly={getIsReadOnly()}
          />
        )}
        {maskType === 'people-names' && (
          <NativeInput
            {...defaultProps}
            keyboardType="default"
            maxLength={100}
            {...masked}
            isReadOnly={getIsReadOnly()}
          />
        )}
        <FormControl.ErrorMessage mt="0">
          {getErrorMessage()}
        </FormControl.ErrorMessage>
      </FormControl>
    </Box>
  );
};

export default MaskedInput;
//           <NativeBaseTextInputMask type={'credit-card'} {...input} />
